module.exports = __webpack_public_path__ + "img/tittle.9452b991.png";